import React, { useState, useEffect, useCallback } from "react";
import Filter from "./reports.view";
import { useTranslation } from "react-i18next";
import PATHS from "../../../constants/paths";
import { BreadCrumb } from "@de-prado-dev/react-component-library";
import * as WorkingPartServices from "../../../services/WorkingPartService";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { REPORT_TYPE_TASK_HOUR } from "../../../constants";
import * as ViveroService from "../../../services/ViveroService";

const ReportsContainer = (props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);
  const [reset, setReset] = useState(undefined);
  const [viveros, setViveros] = useState([]);
  const breads = [
    { label: t("home"), path: PATHS.HOME },
    { label: t("forms.reports.title") },
  ];

  const handlerCleanFilter = async () => {
    // if (resetForm) {
    //   resetForm();
    // }
    if (reset) {
      reset();
    }
    setReset(undefined);
    setFilters(undefined);
  };

  const loadViveros = useCallback(async () => {
    const resultViveros = await ViveroService.getAllViveros();
    if (resultViveros) {
      setViveros(resultViveros);
    }
  }, []);

  useEffect(() => {
    loadViveros();
  }, [loadViveros]);

  const handlerOnSubmitFilter = (values, resetForm) => {
    let newFilter = {};
    const valuesFilters = Object.entries(values);
    valuesFilters.forEach((value) => {
      if (value[1] !== undefined && value[1].toString().length > 0) {
        newFilter[value[0]] = value[1];
      }
    });
    setReset(resetForm);
    setFilters(newFilter);
  };

  useEffect(() => {
    if (filters && filters.type) {
      switch (filters.type) {
        case REPORT_TYPE_TASK_HOUR.code:
          exportToExcelTaskHour(filters);
          break;
        default:
          break;
      }
    }
  }, [filters]);

  const exportToExcelTaskHour = async (filters) => {
    const filter = {
      filters,
      sort: "date",
    };
    WorkingPartServices.reportListTaskHour(filter).then((result) => {
      const data = result.map((item) => {
        return {
          A: item.date,
          B: item.articleName,
          C: item.articleCode,
          D: item.location,
          E: item.sector,
          F: item.batch,
          G: item.culture,
          H: item.variety,
          I: item.amount,
          J: item.hours,
          K: item.minutes,
          L: item.task,
          M: "",
          N: item.month,
          O: item.week,
          P: item.comment,
        };
      });
      data.unshift({
        A: "Fecha parte",
        B: "Nombre Artículo",
        C: "Código Artículo",
        D: "Ubicación",
        E: "Sector",
        F: "Lote",
        G: "Cultura",
        H: "Variedad",
        I: "Cantidad",
        J: "Cálculo horas",
        K: "Cálculo minutos",
        L: "Tarea realizada",
        M: "Especificación tarea vacío",
        N: "Mes",
        O: "Nº Semana",
        P: "Observaciones",
      });
      const filename = `task_hours_export_${moment(new Date()).format(
        "DDMMyyyyHHmm"
      )}`;
      const sheetName = "Hoja 1";
      var ws = XLSX.utils.json_to_sheet(data, {
        header: [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
        ],
        skipHeader: true,
        UTC: true,
        dateNF: "dd-mm-yyyy hh:mm;@",
      });
      // dateNF:'mm/dd/yyyy;@',cellDates:true, raw: true}
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename + ".xlsx");

      handlerCleanFilter();
    });
  };

  return (
    <>
      <div className="row justify-content-center">
        <div className="col-12 col-md-11 marg-btm-1rem marg-top-40px">
          <h3 className="title">{t("forms.reports.title")}</h3>
        </div>
      </div>
      <BreadCrumb items={breads} />
      <div className="row justify-content-center">
        <div className="col-12 col-md-11">
          <Filter
            viveros={viveros}
            onSubmit={handlerOnSubmitFilter}
            // onClean={handlerCleanFilter}
          />
        </div>
      </div>
      {/* {!isTechnical && (
        <div className="row justify-content-center mt-4 no-margin">
          <div className="col-12 col-md-11 text-end">
            <button
              type="button"
              className="btn btn-md btn-secondary"
              onClick={() => exportToExcel()}
            >
              <i className="fa-solid fa-file-excel icon-button"></i>{" "}
              {t("exportFileExcel")}
            </button>
          </div>
        </div>
      )} */}
    </>
  );
};

ReportsContainer.propTypes = {};

export default ReportsContainer;
